import { render, staticRenderFns } from "./midashi1Comment.vue?vue&type=template&id=7887fc18&scoped=true"
import script from "./midashi1Comment.vue?vue&type=script&lang=js"
export * from "./midashi1Comment.vue?vue&type=script&lang=js"
import style0 from "./midashi1Comment.vue?vue&type=style&index=0&id=7887fc18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7887fc18",
  null
  
)

export default component.exports